import { useQuery } from '@apollo/client';
import { IFlightInfo, IFlightInfoRequestParams } from '@transferz/fe-models';

import { FLIGHT_INFO } from '../transitTrackingTypeDefs';

export const useQueryFlightInfo = (options?: {variables: {skip: boolean, params: IFlightInfoRequestParams}}) => (
  useQuery<{flightInfo: IFlightInfo[]}>(FLIGHT_INFO, options)
);
